import { Action } from "redux";
import { AgentGroup } from "../../shared/model/AgentGroup";
import { HashMap } from "../../shared/model/HashMap";
import { State } from "../model/State";

import * as FetchActions from "../actions/FetchActions";
import * as SignalRActions from "../actions/SignalRActions";

import * as ProcessListActions from "../actions/ProcessListActions";

import { AgentProcessModel } from "../model/AgentProcessModel";
import { AgentStatusPerAgentAndProcess } from "../model/AgentStatusPerAgentAndProcess";

export function agentStatuses(state: AgentStatusPerAgentAndProcess = {}, action: Action): AgentStatusPerAgentAndProcess {
    switch (action.type) {
        case FetchActions.RECEIVE_AGENT_STATUSES:
            const receiveAction = action as FetchActions.ReceiveAgentStatusesAction;
            return receiveAction.agentStatuses;
        case SignalRActions.UPDATE_AGENT_STATUSES:
            const updateAction = action as SignalRActions.AgentStatusUpdateAction;
            return Object.assign({}, state, updateAction.agentStatuses);
        default:
            return state;
    }
}
